module.exports = __webpack_public_path__ + "img/map.5caeb472.png";